var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RoulettePreviewExperience',{attrs:{"pockets":_vm.pockets,"rewards":_vm.rewards,"initial-balance":_vm.initialBalance,"deposit-today":_vm.depositToday,"deposit-goal":_vm.depositGoal}})}
var staticRenderFns = []

export { render, staticRenderFns }